import styled from "styled-components";
import { device } from "src/theme/mediaQueries";

export type StyledButtonPropsType = {
  align?: "center" | "left";
  color?: string;
};

export const StyledHeading = styled.h1<StyledButtonPropsType>`
  color: ${({ color }) => color};
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  font-size: ${({ theme }) => theme.fonts.fontSizeXXL};
  font-weight: ${({ theme }) => theme.fonts.fontWeightRegular};
  line-height: 110%;
  margin: 0;
  text-align: ${({ align }) => align};
  white-space: pre-line;

  @media ${device.tabletL} {
    font-size: ${({ theme }) => theme.fonts.fontSizeXL};
  }

  @media ${device.mobileL} {
    font-size: ${({ theme }) => theme.fonts.fontSizeM};
  }
`;
